var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCanto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    height: 16,
    rx: 8,
    width: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m3.52002 5.08423h1.69598v-1.56421h6.784v8.95998h-6.78404v-1.5643h-1.69594zm3.00759-.12419h3.90879v1.58117h-3.90879v2.8987h-1.56349v-2.89882h1.56349zm3.90879 4.48005h-3.90879v1.58121h3.90879z",
    fill: "#06fc99",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanto);
export default __webpack_public_path__ + "static/media/canto.00624fb4e8e1874846c5e023dbb6be82.svg";
export { ForwardRef as ReactComponent };